import Splide from '@splidejs/splide';
//DOM loaded
document.addEventListener("DOMContentLoaded", () => {

    //Carousel init
    let carousel = document.querySelectorAll('.pdw-carousel');
    let carouselArray = new Object();

    carousel.forEach((item, index) => {
        let dataPerviewDefault = parseInt(item.dataset.perview);
        let dataPerview = {
            9999: parseInt(item.dataset.perviewxxl),
            1399: parseInt(item.dataset.perviewxl),
            1199: parseInt(item.dataset.perviewlg),
            991: parseInt(item.dataset.perviewmd),
            767: parseInt(item.dataset.perviewsm),
            575: parseInt(item.dataset.perviewxs)
        }
        let breakPoints = {};
        Object.keys(dataPerview).forEach(key => {
            if (Number.isInteger(dataPerview[key])) {
                breakPoints[key] = {
                    perPage: dataPerview[key]
                };
            } else {
                if (key === '767') {
                    breakPoints[key] = {
                        perPage: 1
                    };
                }
                if (key === '991') {
                    breakPoints[key] = {
                        perPage: (dataPerviewDefault > 1) ? dataPerviewDefault - 1 : 1
                    };
                }
            }
        });
        let dataType = 'loop';
        if ("type" in item.dataset) {
            dataType = item.dataset.type;
        }
        let dataGap = parseInt(item.dataset.gap);
        let dataPeekBefore = 0;
        if ("peekbefore" in item.dataset) {
            dataPeekBefore = parseInt(item.dataset.peekbefore);
        }
        let dataPeekAfter = 0;
        if ("peekafter" in item.dataset) {
            dataPeekAfter = parseInt(item.dataset.peekafter);
        }
        let conf = {
            type: dataType,
            arrows: true,
            pagination: true,
            rewind: false,
            perPage: dataPerviewDefault,
            perMove: 1,
            gap: dataGap + 'px',
            autoplay: false,
            breakpoints: breakPoints,
            padding: {
                left: dataPeekBefore,
                right: dataPeekAfter
            }
        }

        carouselArray['carousel' + index] = new Splide(item, conf);

        let carouselCounter = item.querySelectorAll('.pdw-carousel-counter > .splide');
        if (carouselCounter.length > 0) {
            let confCounter = {
                perPage: 1,
                type: 'fade',
                rewind: true,
                isNavigation: true,
                gap: 0,
                focus: 'center',
                pagination: false,
                arrows: false
            }
            carouselCounter.forEach((counter, indexCounter) => {
                carouselArray['carouselCounter' + index + 'i' + indexCounter] = new Splide(counter, confCounter);
                carouselArray['carousel' + index].sync(carouselArray['carouselCounter' + index + 'i' + indexCounter]);
            });
        }

        let carouselThumbnails = item.querySelectorAll('.pdw-carousel-thumbnails');
        if (carouselThumbnails.length > 0) {
            let confThumbnails = {
                perPage: 1,
                perMove: 1,
                type: 'slide', // 'loop' clonait les vignettes : la même image deux fois sur mobile
                rewind: true,
                isNavigation: true,
                gap: 10,
                pagination: false,
                arrows: false,
                // Configuration par défaut (Desktop)
                direction: 'ttb',
                fixedWidth: 100,
                fixedHeight: 100,
                height: '100vh', // Évite le 100vh qui peut être immense, ajuste selon ton besoin
                breakpoints: {
                    // 991 et non 767 : la galerie s'empile sous lg, et des vignettes verticales en 100vh
                    // y laissaient ~1 000 px de vide sous l'image (tablette).
                    991: {
                        direction: 'ltr', // Left to Right (horizontal)
                        height: 'auto',   // On libère la hauteur fixe
                        focus: 'center'
                    }
                }
            }
            carouselThumbnails.forEach((thumbnails, indexThumbnails) => {
                carouselArray['carouselThumbnails' + index + 'i' + indexThumbnails] = new Splide(thumbnails, confThumbnails);
                carouselArray['carousel' + index].sync(carouselArray['carouselThumbnails' + index + 'i' + indexThumbnails]);
            });
        }
    });

    Object.values(carouselArray).forEach(carouselItem => {
        carouselItem.mount();
    });
});